import React from 'react';

import ButtonDefault from '../../../components/Buttons/ButtonDefault';

import style from './vr360.module.scss';

export default function vr360({ url, empreendimento }) {
  return (
    <div className={style.section}>
      <h2>Visão 360°</h2>
      <h4>
        Faça agora um tour virtual no
        {' '}
        <b>{empreendimento}</b>
        !
      </h4>
      <ButtonDefault
        url={url}
        target='_blank'
        text='Navegar com Visão 360°'
        aria='Navegar com Visão 360°'
      />
    </div>
  );
}
